<template>
  <div class="my-16" :class="$vuetify.breakpoint.smAndDown ? '' : 'step-section'">
    <div class="text-section text-center">
      <!-- <h2 class="step-title accentLightBlue--text mt-16 ma-2 mb-5">
          LANGKAH PENDAFTARAN
        </h2> -->
    </div>
    <!-- Khusus Gel 4, gambar asli: langkah-pendaftaran.jpeg -->
    <expandable-image
      class="img-pendaftaran"
      :src="require('@/assets/img/alur-ppdb.png')"
      alt="langkah-pendaftaran"
      :close-on-background-click="true"
    ></expandable-image>
  </div>
</template>

<script>
export default {
  name: "StepSection",
  data: () => ({
    steps: [
      {
        number: "1",
        text: "Masuk ke akun anda terlebih dahulu atau Daftar jika anda belum punya akun PPDB.",
      },
      {
        number: "2",
        text: "Silahkan pilih dan daftar salah satu jurusan dibawah ini.",
      },
      {
        number: "3",
        text: "Isi formulir pendaftaran dan kirim.",
      },
      {
        number: "4",
        text: "Tunggu sampai formulir pendaftaran anda dikonfirmasi oleh admin.",
      },
      {
        number: "5",
        text: "Silahkan cek menu Kotak Masuk untuk melihat apakah formulir pendaftaran anda dikonfirmasi atau ditolak oleh Admin.",
      },
      {
        number: "6",
        text: "Jika berkas formulir anda ada yang ditolak oleh Admin, anda bisa mengupload ulang di menu Berkas.",
      },
      {
        number: "7",
        text: "Jika formulir anda telah dikonfirmasi oleh admin, anda bisa menuju ke menu Berkas untuk melihat tata cara pembayaran biaya pendaftaran.",
      },
      {
        number: "8",
        text: "Tunggu sampai pembayaran biaya pendaftaran anda dikonfirmasi oleh admin.",
      },
      {
        number: "9",
        text: "Anda akan mendapatkan dua data setelah pembayaran anda dikonfirmasi admin, yaitu Cetakan Formulir Pendaftaran dan Kartu Tes di menu Cetak Data.",
      },
      {
        number: "10",
        text: "Pendaftaran anda telah berhasil.",
      },
    ],
  }),
};
</script>

<style scoped>
.img-pendaftaran {
  width: 87%;
  margin: auto;
  filter: drop-shadow(1px -2px 21px rgba(0, 0, 0, 0.18));
}

/* .step-section {
  background-image: url("../../assets/img/bg_home_section_top.svg"), url("../../assets/img/bg_home_section_bottom.svg");
  background-position: top left, bottom right;
  background-size: 22rem;
  background-repeat: no-repeat;
} */

.step-card {
  width: 800px;
  display: grid;
  grid-template-columns: 13px auto;
  grid-gap: 25px;
}

.step-title {
  display: block;
}

.step-card .left-stick {
  width: 100%;
  height: 100%;
  border-radius: 20px;
}

.step-card .steps {
  display: grid;
  grid-template-rows: min-content auto;
}

.step-card .step {
  display: grid;
  grid-template-columns: min-content auto;
  grid-gap: 10px;
}

.step-card .step h5 {
  font-size: 18px;
}

.step-card .step p {
  font-size: 16px;
  vertical-align: middle;
}

@media screen and (max-width: 900px) {
  .step-card {
    width: 90%;
  }

  .step-title {
    display: none;
  }

  .img-pendaftaran {
    width: 100%;
    border: none;
    margin: 0 !important;
  }
}

@media screen and (max-width: 676px) {
  .step-card {
    grid-template-columns: 10px auto;
    grid-gap: 15px;
  }

  .step-card .step h5 {
    font-size: 16px;
  }

  .step-card .step p {
    font-size: 14px;
  }

  .step-card .step-title {
    font-size: 18px;
  }

  .step-title {
    display: none;
  }

  .img-pendaftaran {
    width: 100%;
    margin: 0 !important;
    border: none;
  }
}

@media screen and (max-width: 550px) {
  .step-card {
    grid-template-columns: 10px auto;
    grid-gap: 0;
  }

  .step-card .step h5 {
    font-size: 14px;
  }

  .step-title {
    display: none;
  }

  .img-pendaftaran {
    width: 100%;
    border: none;
    margin: 0 !important;
  }

  .step-card .step p {
    font-size: 12px;
  }
}
</style>
